module.exports = __webpack_public_path__ + "img/icon-ywqn-head-2.3c7fd173.png";